import MobileSliderPagesWrapper from '../../components/MobileSliderPagesWrapper';
import MobileSliderPagesHeader from '../../components/MobileSliderPagesHeader';
import {
    MobileSliderPagesContentCommunityItemStyled,
    MobileSliderPagesContentCommunityStyled,
} from './styled/SlideMobileCommunityStyled';
import { YoutubeBanner } from './banners/YoutubeBanner';
import { InstagramBanner } from './banners/InstagramBanner';
import { FacebookBanner } from './banners/FacebookBanner';
import { TelegramBanner } from './TelegramBanner';
import { useLangContext } from '../../../../../providers/LangProvider/LangProviderContext';

function SlideMobileCommunity() {
    const { getLangPath } = useLangContext();

    const goto = (prefix) => {
        const url = getLangPath(`community.url.${prefix}`);
        return () => window.open(url);
    };

    return <MobileSliderPagesWrapper backgroundColor='var(--color-background-primary)'>
        <MobileSliderPagesHeader goBack>
            <h4 className='mb-0 text-center fw600 f16'>{getLangPath(`community.header`)}</h4>
        </MobileSliderPagesHeader>
        <MobileSliderPagesContentCommunityStyled>
            <MobileSliderPagesContentCommunityItemStyled onClick={goto('youtube')}>
                <YoutubeBanner/>
            </MobileSliderPagesContentCommunityItemStyled>
            <MobileSliderPagesContentCommunityItemStyled onClick={goto('instagram')}>
                <InstagramBanner/>
            </MobileSliderPagesContentCommunityItemStyled>
            <MobileSliderPagesContentCommunityItemStyled onClick={goto('facebook')}>
                <FacebookBanner/>
            </MobileSliderPagesContentCommunityItemStyled>
            <MobileSliderPagesContentCommunityItemStyled onClick={goto('telegram')}>
                <TelegramBanner/>
            </MobileSliderPagesContentCommunityItemStyled>
        </MobileSliderPagesContentCommunityStyled>
    </MobileSliderPagesWrapper>;
}

export default SlideMobileCommunity;
